import React from 'react';

export default function ScrollBlock(props) {
    return <div className={`scroll-block ${props.className}`} style={props.style}>
            {props.children}
           </div>
}